module.exports = __webpack_public_path__ + "static/img/014.35fb769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/014.png
// module id = TtyF
// module chunks = 0